import styled from 'styled-components';

export default styled.div`
  color: ${p => p.theme.color.textPrimary};
  font-family: ${p => p.theme.font.sourceSans};
  font-size: 16px;

  @media ${p => p.theme.media.largePhone} {
    font-size: 12px;
  }
`;
